/**
 * Local shim for react-scroll-pagination v0.1.9
 * The original package uses React.createClass and React.PropTypes which were
 * removed in React 16+. This reimplements the same scroll-pagination behavior
 * using modern React (class component for compatibility with the rest of this codebase).
 */
import React, { Component } from 'react';
import $ from 'jquery';

const pageDivStyle = {
  position: 'fixed',
  bottom: '15px',
  left: 0,
  right: 0,
  textAlign: 'center'
};

const pageContentStyle = {
  display: 'inline-block',
  background: 'rgba(6, 6, 6, 0.54)',
  borderRadius: '5px',
  padding: '3px 15px',
  minWidth: '80px',
  color: '#fff',
  textAlign: 'center',
  margin: '0 auto',
  opacity: 1,
  WebkitTransition: 'opacity 0.8s',
  MozTransition: 'opacity 0.8s',
  OTransition: 'opacity 0.8s',
  transition: 'opacity 0.8s'
};

class ReactScrollPagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      totalPages: null,
      showPageStatus: false
    };
    this.onePageHeight = null;
    this.timeoutFuncHandler = null;
    this.excludeHeight = null;
    this.triggerAt = null;
    this.showTime = null;
    this.defaultShowTime = 2000;
    this.defaultTrigger = 30;
    this.defaultExcludeHeight = 0;
    this.scrollHandler = this.scrollHandler.bind(this);
  }

  componentDidMount() {
    this.validateAndSetPropValues();
    $(window).on('scroll', this.scrollHandler);
  }

  componentWillUnmount() {
    $(window).off('scroll', this.scrollHandler);
    if (this.timeoutFuncHandler) {
      clearTimeout(this.timeoutFuncHandler);
    }
  }

  getShowTime() {
    let showTime = this.defaultShowTime;
    if (this.props.paginationShowTime) {
      showTime = parseInt(this.props.paginationShowTime, 10);
      if (isNaN(showTime)) {
        showTime = this.defaultShowTime;
      }
    }
    return showTime;
  }

  getExcludeHeight() {
    let excludeHeight = this.defaultExcludeHeight;
    if (this.props.excludeHeight) {
      const propsExcludeHeight = parseInt(this.props.excludeHeight, 10);
      if (!isNaN(propsExcludeHeight)) {
        excludeHeight = propsExcludeHeight;
      }
    } else if (this.props.excludeElement && typeof this.props.excludeElement === 'string') {
      const excludeEle = $(this.props.excludeElement);
      if (excludeEle.length > 0) {
        excludeHeight = excludeEle.height();
      }
    }
    this.excludeHeight = excludeHeight;
    return excludeHeight;
  }

  getTriggerAt() {
    let triggerAt = this.defaultTrigger;
    if (this.props.triggerAt) {
      triggerAt = parseInt(this.props.triggerAt, 10);
      if (isNaN(triggerAt)) {
        triggerAt = this.defaultTrigger;
      }
    }
    return triggerAt;
  }

  getOnePageHeight() {
    const documentHeight = $(document).height();
    if (typeof this.props.totalPages === 'number' && this.props.totalPages > 0 && this.onePageHeight === null) {
      this.onePageHeight = documentHeight - this.excludeHeight;
    }
  }

  showPagePositionDiv() {
    if (this.timeoutFuncHandler) {
      clearTimeout(this.timeoutFuncHandler);
    }
    this.setState({ showPageStatus: true });
    this.timeoutFuncHandler = setTimeout(() => {
      this.setState({ showPageStatus: false });
    }, this.showTime);
  }

  handlePagePosition() {
    this.getOnePageHeight();
    const windowHeight = $(window).height();
    const scrollTop = $(window).scrollTop() + windowHeight - this.excludeHeight;
    if (this.onePageHeight !== null) {
      const currentPage = Math.ceil(scrollTop / this.onePageHeight) || 1;
      this.setState({ currentPage });
      this.showPagePositionDiv();
    }
  }

  scrollHandler() {
    const documentHeight = $(document).height();
    const windowHeight = $(window).height();
    const scrollBottom = $(window).scrollTop() + windowHeight;
    const triggerBottom = scrollBottom + this.triggerAt;

    if (triggerBottom >= documentHeight) {
      this.props.fetchFunc();
    }
    this.handlePagePosition();
  }

  validateAndSetPropValues() {
    this.triggerAt = this.getTriggerAt();
    this.excludeHeight = this.getExcludeHeight();
    this.showTime = this.getShowTime();
  }

  render() {
    if (typeof this.props.totalPages === 'undefined') {
      return null;
    }

    const actualPageContentDivStyle = { ...(this.props.innerDivStyle || pageContentStyle) };
    if (!this.state.showPageStatus) {
      actualPageContentDivStyle.opacity = 0;
    }

    return (
      <div style={this.props.outterDivStyle || pageDivStyle}>
        <div style={actualPageContentDivStyle} className="react-scroll-pagination-inner-div">
          <span>{this.state.currentPage}</span>/<span>{this.props.totalPages || 1}</span>
        </div>
      </div>
    );
  }
}

export default ReactScrollPagination;
